(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/detail-view-route-result-handler/assets/javascripts/detail-view-route-result-handler.js') >= 0) return;  svs.modules.push('/components/tipsen/detail-view-route-result-handler/assets/javascripts/detail-view-route-result-handler.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _ReactRouterDOM = ReactRouterDOM,
  Route = _ReactRouterDOM.Route,
  useRouteMatch = _ReactRouterDOM.useRouteMatch;
const useMediaQuery = svs.components.lbUtils.useMediaQuery.useMediaQuery;
const _svs$components$tipse = svs.components.tipsen.sideNav,
  SideNav = _svs$components$tipse.SideNav,
  LazyStatistic = _svs$components$tipse.LazyStatistic,
  LazyWinnerstories = _svs$components$tipse.LazyWinnerstories,
  LazyCompetitionResult = _svs$components$tipse.LazyCompetitionResult,
  LazyQuickBet = _svs$components$tipse.LazyQuickBet;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const _svs$components$tipse2 = svs.components.tipsen.hooks,
  useBranding = _svs$components$tipse2.useBranding,
  useGetIsMatchNotStartedOrLive = _svs$components$tipse2.useGetIsMatchNotStartedOrLive;
const _svs$components$tipse3 = svs.components.tipsen.drawProvider.hooks,
  useCurrentDrawEvent = _svs$components$tipse3.useCurrentDrawEvent,
  useDrawSearchParams = _svs$components$tipse3.useDrawSearchParams,
  useCurrentDraw = _svs$components$tipse3.useCurrentDraw;
const STATISTIC_SIDEBAR_QUERY = svs.components.tipsen.constants.STATISTIC_SIDEBAR_QUERY;
const SportinfoPathNames = svs.components.sportinfo.common.constants.SportinfoPathNames;
const DetailViewMobileHandler = svs.components.tipsen.detailViewMobileHandler.DetailViewMobileHandler;
const useGetSelectedEventNumber = svs.components.tipsen.hooks.useGetSelectedEventNumber;
const _svs$components$marke = svs.components.marketplaceCompetition.services.hooks,
  useCompetitionDesc = _svs$components$marke.useCompetitionDesc,
  useCompetitionType = _svs$components$marke.useCompetitionType;
const CompetitionType = svs.components.marketplaceCompetition.constants.CompetitionType;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const getMenuItems = (drawSearchParams, menuItemPathsPrefix, competitionId, competitionDesc, compSubUrl, drawNumber, isMatchNotStartedOrLive, matchId, sportType, shouldBlurCompetitionContent) => {
  var _svs$tipsen$data$winn, _svs;
  const menuItems = {
    STATISTICS: {
      to: {
        pathname: '',
        search: drawSearchParams
      },
      icon: 'statistics',
      label: 'Statistik',
      testIdSuffix: 'statistic',
      Component: LazyStatistic,
      selectedOnPaths: ["/".concat(menuItemPathsPrefix), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.News), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Table), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Statistic), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Lineup), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Mutuals), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.Events), "/".concat(menuItemPathsPrefix, "/").concat(SportinfoPathNames.PlayMakerXstat)]
    },
    WINNERSTORIES: {
      to: {
        pathname: '/vinnarstories',
        search: drawSearchParams
      },
      icon: 'win',
      label: 'Vinnarstories',
      testIdSuffix: 'winnerstories',
      Component: LazyWinnerstories,
      selectedOnPaths: ["/".concat(menuItemPathsPrefix, "/vinnarstories")]
    },
    TIPSSM: {
      to: {
        pathname: "/".concat(compSubUrl),
        search: drawSearchParams
      },
      icon: 'trophy-tips-sm',
      label: competitionDesc,
      testIdSuffix: 'tipssm',
      Component: LazyCompetitionResult,
      selectedOnPaths: ["/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.TIPS_SM, "(/lag)?"), "/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.TIPS_SM, "/lag/:teamId(\\d+)?"), "/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.TIPS_EM, "(/lag)?"), "/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.TIPS_EM, "/lag/:teamId(\\d+)?")],
      props: {
        competitionId,
        drawNumber,
        shouldBlurCompetitionContent
      }
    },
    QUICKBET: {
      to: {
        pathname: "/".concat(TipsenModuleGameUrl.QUICK_BET),
        search: drawSearchParams
      },
      icon: 'odds',
      label: 'Oddset',
      testIdSuffix: 'quickbet',
      Component: LazyQuickBet,
      selectedOnPaths: ["/".concat(menuItemPathsPrefix, "/").concat(TipsenModuleGameUrl.QUICK_BET)],
      props: {
        matchId,
        sportType
      }
    }
  };
  const menuItemsList = [menuItems.STATISTICS];
  const smallDeviceMenuItemsList = [menuItems.STATISTICS];
  if (isMatchNotStartedOrLive && sportType && matchId) {
    menuItemsList.push(menuItems.QUICKBET);
    smallDeviceMenuItemsList.push(menuItems.QUICKBET);
  }
  const winnerStoriesEnabled = (_svs$tipsen$data$winn = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.tipsen) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.winnerStoriesConfig) === null || _svs === void 0 || (_svs = _svs.winnerStories) === null || _svs === void 0 ? void 0 : _svs.enabled) !== null && _svs$tipsen$data$winn !== void 0 ? _svs$tipsen$data$winn : false;
  if (winnerStoriesEnabled) {
    menuItemsList.push(menuItems.WINNERSTORIES);
  }
  if (competitionId) {
    menuItemsList.unshift(menuItems.TIPSSM);
  }
  return [menuItemsList, smallDeviceMenuItemsList];
};
const DetailViewRouteResultHandler = _ref => {
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId,
    menuItemPathsPrefix = _ref.menuItemPathsPrefix,
    _ref$hasSideNav = _ref.hasSideNav,
    hasSideNav = _ref$hasSideNav === void 0 ? true : _ref$hasSideNav,
    competitionId = _ref.competitionId,
    _ref$maskedOutcomes = _ref.maskedOutcomes,
    maskedOutcomes = _ref$maskedOutcomes === void 0 ? [] : _ref$maskedOutcomes,
    _ref$shouldBlurCompet = _ref.shouldBlurCompetitionContent,
    shouldBlurCompetitionContent = _ref$shouldBlurCompet === void 0 ? false : _ref$shouldBlurCompet;
  const sideNavOverflowClass = 'tipsen-side-nav-overflow';
  const isWideDevice = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  const match = useRouteMatch();
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const event = useCurrentDrawEvent(drawId);
  const draw = useCurrentDraw();
  let sportType;
  if (draw) {
    sportType = draw.sportType;
  }
  const matchId = event.matchId;
  const selectedEventNumber = useGetSelectedEventNumber();
  const drawSearchParams = useDrawSearchParams(productId, drawNumber, selectedEventNumber, true).toString();
  const brandingByDraw = getProductBrandByDraw({
    productId
  });
  const brandingList = useBranding();
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const competitionDesc = useCompetitionDesc(competitionId);
  const competitionType = useCompetitionType(competitionId);
  const compSubUrl = competitionType === CompetitionType.TipsEM ? TipsenModuleGameUrl.TIPS_EM : TipsenModuleGameUrl.TIPS_SM;
  const isMatchNotStartedOrLive = useGetIsMatchNotStartedOrLive(matchId);
  const hasCompetition = competitionId && competitionType && competitionDesc;
  const _getMenuItems = getMenuItems(drawSearchParams, menuItemPathsPrefix, hasCompetition ? competitionId : undefined, competitionDesc, compSubUrl, drawNumber, isMatchNotStartedOrLive, matchId, sportType, shouldBlurCompetitionContent),
    _getMenuItems2 = _slicedToArray(_getMenuItems, 2),
    menuItems = _getMenuItems2[0],
    smallDeviceMenuItems = _getMenuItems2[1];
  const eventIndex = event.eventNumber - 1;
  const eventCount = draw === null || draw === void 0 ? void 0 : draw.eventCount;
  const matchCount = draw === null || draw === void 0 ? void 0 : draw.matchCount;
  const hasPeriods = matchCount === 1 && eventCount > 1;
  const hasMaskedOutcomes = maskedOutcomes.includes(eventIndex) || hasPeriods && maskedOutcomes.length > 0;
  const ariaLabel = hasCompetition ? 'Tävlingsinformation och statistik' : 'Statistik';
  if (isWideDevice && hasSideNav) {
    return React.createElement(SideNav, {
      ariaLabel: ariaLabel,
      match: match,
      menuItems: menuItems
    }, React.createElement(Route, {
      render: () => React.createElement(LazyStatistic, {
        bigStattabAreaClassName: sideNavOverflowClass,
        branding: branding,
        drawNumber: drawNumber,
        hasMaskedOutcomes: hasMaskedOutcomes,
        matchId: matchId,
        productId: productId,
        shouldSaveDrawParams: true
      })
    }));
  } else if (!isWideDevice) {
    return React.createElement(DetailViewMobileHandler, {
      drawId: drawId,
      extraMenuItems: smallDeviceMenuItems,
      hasMaskedOutcomes: hasMaskedOutcomes
    }, React.createElement(LazyStatistic, {
      branding: branding,
      drawNumber: drawNumber,
      hasMaskedOutcomes: hasMaskedOutcomes,
      matchId: matchId,
      productId: productId,
      shouldSaveDrawParams: true
    }));
  }
  return null;
};
setGlobal('svs.components.tipsen.detailViewRouteResultHandler.DetailViewRouteResultHandler', DetailViewRouteResultHandler);

 })(window);